import React from 'react';
import { differencesContent } from '../data/mock';
import { getImageUrl } from '../lib/api';
import { Check } from 'lucide-react';

const DifferencesSection = () => {
  return (
    <section className="py-20 lg:py-32 bg-white" id="differences">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="aspect-[4/3] bg-slate-100 rounded-2xl overflow-hidden shadow-lg">
              <img
                src={getImageUrl(differencesContent.image)}
                alt={differencesContent.altText}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.classList.add('flex', 'items-center', 'justify-center');
                  e.target.parentElement.innerHTML = '<div class="text-slate-400 text-center p-8"><div class="w-20 h-20 mx-auto mb-4 bg-slate-200 rounded-lg"></div><span class="text-sm">Salīdzinājuma attēls</span></div>';
                }}
              />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2 space-y-8">
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 leading-tight">
              {differencesContent.title}
            </h2>

            <ul className="space-y-4">
              {differencesContent.bullets.map((bullet, index) => (
                <li
                  key={index}
                  className="flex items-start space-x-4 p-4 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors"
                >
                  <div className="w-6 h-6 bg-emerald-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Check className="w-4 h-4 text-white" />
                  </div>
                  <span className="text-slate-700 font-medium">{bullet}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DifferencesSection;
